import { createAppSelector } from "./base";

import { RootState } from "store";

export const selectCourseVersion = (state: RootState) => state.view.courseVersion;

export const selectWebsocketUserEmail = (state: RootState) => state.auth.websocket?.email;
export const selectWebsocketCourseId = (state: RootState) => state.auth.websocket?.course_id;
export const selectUserIsInactive = (state: RootState) => state.view.userIsInactive;

export const selectIsCourseVersionOutOfSync = (state: RootState) =>
  state.view.isCourseVersionOutOfSync;

export const selectAssetModalIsOpen = (state: RootState) => state.view.assetModalIsOpen;
export const selectPreventFeatureModalClosing = (state: RootState) =>
  state.view.preventFeatureModalClosing;
export const selectFeaturingPdfState = (state: RootState) => state.view.featuringPdfState;
export const selectIsGroupConfigShown = (state: RootState) => state.view.isGroupConfigShown;

export const selectIsStudentPreview = (state: RootState) => state.view.isStudentPreview;
export const selectIsTimeline = (state: RootState) => state.view.isTimeline;

export const selectShouldResetPageTab = (state: RootState) => state.view.shouldResetPageTab;

export const selectSelectedPageBlockIndex = (state: RootState) => state.view.selectedPageBlockIndex;
export const selectCurrentAvailablePageBlocks = (state: RootState) =>
  state.view.currentAvailablePageBlocks;

export const selectShouldShowAssessmentSummary = (state: RootState) =>
  state.view.shouldShowAssessmentSummary;
export const selectShouldShowModalOnExitAssessmentMode = (state: RootState) =>
  state.view.shouldShowModalOnExitAssessmentMode;

export const selectSelectedPageTabVariant = (state: RootState) => state.view.selectedPageTabVariant;

export const selectShareDBOpStatus = createAppSelector(
  [
    (state) => state.view.lastOpAt,
    (state) => state.view.lastOpSavedAt,
    (state) => state.view.opError,
  ],
  (lastOpAt, lastOpSavedAt, opError) => ({
    lastOpAt,
    lastOpSavedAt,
    opError,
  }),
);

export const selectQueryString = (state: RootState) => state.view.queryParams;

export const selectCourseSettingsTabIndex = (state: RootState) => state.view.courseSettingsTabIndex;

export const selectAdminCourseId = (state: RootState) => state.view.adminCourseId;

export const selectConnectionQuality = (state: RootState) => state.view.connectionQuality;

export const selectProjectorHeight = (state: RootState) => state.view.projectorHeight;

export const selectStoredCollaborationServerVersion = (state: RootState) =>
  state.view.storedCollaborationServerVersion;

export const selectShowForceReloadModal = (state: RootState) => state.view.showForceReloadModal;

export const selectProjectorFeaturedAssetContainer = (state: RootState) =>
  state.view.projectorFeaturedAssetContainer;
